import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";
import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as _cv_61 from './_cv_61___Mz';

let $_61z = _cv_61.itl_61z();

import { useMsgz } from "./_csMdlMsg";
import * as BtnCttC from './_ccmBtnCttC';

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {

          if (pz.cz.bfrUgdAsync) await pz.cz.bfrUgdAsync($_61z);

          // 外部連携されてない休館日を外部連携
          const _61z = await _cv_61.save_61rDzAsync({
            ... pz,
            _61z: $_61z,
          });
          return {
            _61r_fst: _61z._61rz._fst,
          };

        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {

    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        _cv_61.crt_61z()
        .then((_dz: ht.dz) => {
          $_61z = _dz;
        })
      ],
      udtAsync: () => [
        _cv_61.load_61rDzAsync({
          _61r_fst: pz.sPz.crt._61r_fst,
          cdn: 'true',
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          $_61z = _dz;
        })
      ],
    });

  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._61r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;

  _hdrs.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '休館日'
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
        ]
      },
    ],
  });

  const _bdys = [] as ht.ls;
  $_61z._611s
  .filter( ( _611z:ht.dz ) => _611z._dlt != 1 )
  .map( ( _611z:ht.dz ) => {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: 
                  _611z._key > 0 ? // 一度登録した日付は変更不可（削除し再登録）
                    false
                  : hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'dtm',
//                vle: _611z._icn ?? hfDTM.getTdy(),
                vle: _611z._icn ?? '',
                onChg: ( _dtm: ht.s ) => {
                  //hf.l(`_cv_61b 112: ${_dtm}`)
                  _611z._icn = _dtm;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  _611z._dlt = 1;
                  _frcUdt();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });
  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $_61z._611s.push(ihd.i(`_611`));
                  _frcUdt();
                },
              }
            })
          ]
        },
      ],
    });
  }

  //hf.l(`_cv_61b 157: ${hf.s($_61z)}`);
  return (
    cr.c(BoxC.N, {
      key: '_61b.Root',
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `対象年`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_61z._61rz._icn ?? '',
                              onChg: (_s: ht.s) => {
                                $_61z._61rz._icn = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(TblC.N, {
          key: -20,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50'),
            }
          },
          hdrCz: {
            lineCs: _hdrs
          },
          bdyCz: {
            lineCs: _bdys
          }
        })

      ]
    })
  );
};

